class Logger {
  private _scope: string;

  constructor(scope: string) {
    this._scope = scope;
  }

  log(...args: unknown[]) {
    if (import.meta.env.VITE_CONSOLE_LOGS === 'true') {
      console.log(this._scope, ...args);
    }
  }

  logError(...args: unknown[]) {
    console.error(this._scope, ...args);
  }
}

export const logger = new Logger('[PlayFrame]: ');
